<template>
    <div style="margin-top: 2%; width: 100%;">

    <div class="toolbar__container" style="width: 80vw; margin: 0 auto;">
      <v-form ref="form" v-model="formValidado">
        <v-row>
          <v-col cols="12" sm="6" md="3">
            <v-autocomplete v-model="idEmpresaSelected" :items="empresas" item-text="razao_social"
              item-value="id_empresa" clearable :label="$tc('company.self', 1)"
              @change="empresaChanged"></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-autocomplete v-model="idTipoCercaSelected" :items="tiposCercas" item-text="descricao_tipo_cerca"
              item-value="id_tipo_cerca" clearable :label="$t('geofenceVehicles.typeGeofence')"
              @change="tipoCercaChanged"></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="10" md="4">
            <v-autocomplete v-model="idCercasSelected" :items="cercasSelect" item-text="nome_cerca"
              item-value="id_cerca" clearable multiple :label="$tc('geofence.self', 1)" @change="cercaChanged"
              :rules="[(v) => v.length > 0 || $t('geofenceVehicles.rules.selectGeofence')]"></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="4" md="1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn small fab color="primary darken-1" class="white--text" v-bind="attrs" v-on="on"
                  @click="populaRelatorio">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('operation.search') }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="6">
            <v-autocomplete v-model="idLinhaSelected" :items="linhasSelect" item-text="nome_linha" item-value="id_linha"
              clearable multiple :label="$tc('line.self', 1)" @change="linhaChanged"></v-autocomplete>
          </v-col>
        </v-row>
      </v-form>
    </div>

    <div style="width: 80vw; height: 80vh; margin: 0 auto;">
      <v-navigation-drawer v-model="showDrawer" absolute temporary overlay-opacity="0" left
        style="width: 20vw; height: 100vh; z-index: 10; margin-top: 20px;">
        <v-toolbar flat style="border-radius: 10px; margin-top: 5px">
          <v-toolbar-title>
            <strong>{{ $t('geofenceVehicles.vehiclesInGeofence') }}</strong>
          </v-toolbar-title>
        </v-toolbar>
        <v-list three-line calss="overflow-y-auto">
          <v-list-item v-for="(veiculo, v) in veiculosFiltered" :key="`DRAWER-${veiculo.numero_ordem}-${v}`"
            @click="veiculoClicked(veiculo)">
            <v-list-item-content>
              <v-list-item-title>{{ veiculo.numero_ordem }}</v-list-item-title>
              <v-list-item-subtitle>
                <span>{{ $t('geofenceVehicles.validator') }}: {{ veiculo.descricao_status_validador }}</span>
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                <span>{{ $tc('geofence.self', 1) }}: {{ veiculo.nome_cerca }}</span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>
      <l-map ref="map" :zoom="15" :center="currentCenter" :minZoom="3" :maxZoom="18" @ready="onMapPlotagemResize"
        :options="mapOptions" v-resize="onMapPlotagemResize" style="border-radius: 10px; margin-top: 5px; z-index: 1">

        <l-tile-layer :url="url" :attribution="attribution" />

        <l-control :position="'topright'" class="text-overlay">
          <v-row>
            <v-col cols="12" sm="5" md="5">
              <v-checkbox v-model="showCercas" :label="$tc('geofence.self', 2)"></v-checkbox>
            </v-col>
            <v-col cols="12" sm="5" md="5">
              <v-checkbox v-model="showVeiculos" :label="$tc('vehicle.self', 2)"></v-checkbox>
            </v-col>
          </v-row>
        </l-control>

        <l-control :position="'topleft'">
          <v-btn small fab @click="showDrawer = true">
            <v-icon color="black">mdi-bus</v-icon></v-btn>
        </l-control>

        <!-- Render non-circular cercas with GeoJSON -->
        <l-geo-json v-for="(cerca, c) in cercasRelatorioNaoCirculares" :key="`GEOJSON-${cerca.id_cerca}-${c}`" 
          :geojson="cerca.geojson"
          :visible="showCercas && !!cerca.geojson"></l-geo-json>
        
        <!-- Render circular cercas with LCircle -->
        <l-circle v-for="(cerca, c) in cercasRelatorioCirculares" :key="`CIRCLE-${cerca.id_cerca}-${c}`"
          :radius="cerca.raio_mts || 100"
          :lat-lng="[parseFloat(cerca.lat_centro), parseFloat(cerca.lng_centro)]"
          :visible="showCercas && !!cerca.lat_centro && !!cerca.lng_centro"></l-circle>

        <l-marker v-for="(veiculo, v) in veiculosFiltered" :lat-lng="getPosicaoVeiculo(veiculo)"
          :key="`${veiculo.id_veiculo}-${v}`" :icon="getIcon(veiculo)" :visible="showVeiculos">
          <l-tooltip :content="veiculo.numero_ordem"
            :options="{ permanent: false, direction: 'top', opacity: 1.0, className: 'veiculo__tooltip' }"></l-tooltip>
        </l-marker>
      </l-map>
    </div>
  </div>
</template>

<script>
import apiController from "@/utils/apiController";
import L from "leaflet";
import {
  LMap,
  LTileLayer,
  LMarker,
  LTooltip,
  LGeoJson,
  LCircle,
  LControl
} from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import translateDbField from "@/utils/translateDbField";

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LTooltip,
    LGeoJson,
    LCircle,
    LControl
  },
  data: () => ({
    search: "",
    user: null,
    token: null,
    formValidado: false,
    loading: false,
    timeProps: {
      useSeconds: true,
    },
    dti: null,
    idEmpresaSelected: null,
    idTipoCercaSelected: null,
    idCercasSelected: [],
    idLinhaSelected: [],
    isLinhaSelectDisabled: false,
    empresas: [],
    veiculos: [],
    linhas: [],
    linhasSelect: [],
    cercas: [],
    cercsaUnicas: [],
    cercasSelect: [],
    tiposCercas: [],
    config: null,
    mapOptions: {
      zoomSnap: 0.5,
    },
    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    attribution:
      '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    currentCenter: [-22.88746, -43.29185],
    showCercas: true,
    showVeiculos: true,
    veiculoSelected: null,
    showDrawer: false,
  }),
  computed: {
    center() {
      return this.$store.getters['config/centerDefault'];
    },
    textFieldProps() {
      return {
        prependInnerIcon: "mdi-calendar",
        rules: [(v) => !!v || this.$t('contract.messages.selectDate')], // (v) => v > this.dtfimbase || "Data início deve ser menor que data fim !"]
      }
    },
    veiculosFiltered() {
      let veiculos = this.veiculos;

      if (this.idEmpresaSelected) {
        veiculos = veiculos.filter((v) => v.id_empresa == this.idEmpresaSelected);
      }

      if (this.idLinhaSelected.length > 0) {
        veiculos = veiculos.filter((v) => this.idLinhaSelected.includes(v.id_linha));
      }

      if (this.idTipoCercaSelected) {
        veiculos = veiculos.filter((v) => v.id_tipo_cerca == this.idTipoCercaSelected);
      }

      return veiculos;
    },
    cercasRelatorio() {
      return this.cercas.filter((c) => 
        this.idCercasSelected.includes(c.id_cerca) && 
        c.lat_centro && 
        c.lng_centro
      );
    },
    cercasRelatorioCirculares() {
      return this.cercasRelatorio.filter((c) => 
        c.is_circular == 1 && c.raio_mts
      );
    },
    cercasRelatorioNaoCirculares() {
      return this.cercasRelatorio.filter((c) => 
        (c.is_circular != 1 || !c.raio_mts) && c.geojson !== null
      );
    }
  },
  watch: {
    '$i18n.locale'() {
      this.initialize();
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    }
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.token = sessionStorage.getItem("api");
    this.initialize();
  },
  mounted() { },
  methods: {
    initialize() {
      this.getConfig();
      this.populaEmpresas();
      this.populaLinhas();
      this.populaTiposCercas();
      this.populaCercas();
    },
    getConfig() {
      apiController.request(apiController.endpoints.getallConfig, {
        onSuccess: (response) => {
          this.config = response.data[0];
          this.dti = new Date();
        }
      });
    },
    populaEmpresas() {
      apiController.request(apiController.endpoints.getallEmpresas, {
        onSuccess: (response) => {
          this.empresas = response.data;
        }
      });
    },
    populaLinhas() {
      apiController.request(apiController.endpoints.getLinhasativas, {
        onSuccess: (response) => {
          this.linhas = response.data;
          this.populaLinhasSelect();
        }
      });
    },
    populaCercas() {
      apiController.request(apiController.endpoints.getallCercasativascomtipo, {
        onSuccess: (response) => {
          this.cercas = response.data.map((c) => {
            // Safely parse geojson, handle null or empty strings
            if (c.geojson && c.geojson.trim() !== '') {
              try {
                c.geojson = JSON.parse(c.geojson);
              } catch (e) {
                console.warn('Failed to parse geojson for cerca:', c.id_cerca, e);
                c.geojson = null;
              }
            } else {
              c.geojson = null;
            }
            return c;
          });
          this.cercasUnicas = [];
          this.cercas.forEach((c) => {
            if (this.cercasUnicas.findIndex((e) => e.id_cerca === c.id_cerca) === -1) {
              this.cercasUnicas.push(c)
            }
          });
          this.populaCercasSelect();
        }
      });
    },
    populaTiposCercas() {
      apiController.request(apiController.endpoints.getTiposcerca, {
        onSuccess: (response) => {
          this.tiposCercas = response.data.map(tipoCerca => {
                    const translated = translateDbField(
                        tipoCerca.translation_key,
                        tipoCerca.descricao_tipo_cerca
                    );
                    return {
                        ...tipoCerca,
                        descricao_tipo_cerca: translated
                    };
                });
        }
      });
    },
    populaLinhasSelect() {
      if (this.idEmpresaSelected) {
        this.linhasSelect = this.linhas.filter((l) => l.id_empresa == this.idEmpresaSelected);
      } else {
        this.linhasSelect = this.linhas;
      }
    },
    populaCercasSelect() {
      if (this.idTipoCercaSelected) {
        this.cercasSelect = this.cercasUnicas.filter((c) => c.id_tipo_cerca == this.idTipoCercaSelected);
      } else {
        this.cercasSelect = this.cercasUnicas;
      }
    },
    populaVeiculos() {
      this.loading = true;

      let temp = {
        idcercas: this.idCercasSelected.length > 0 ? this.idCercasSelected : this.cercasSelect.map((c) => c.id_cerca)
      }

      apiController.request(apiController.endpoints.getVeiculoscercastemporeal, {
        data: temp,
        onSuccess: (response) => {
          this.veiculos = response.data.map((v) => {
            const translated = translateDbField(
              v.status_validador_translation_key,
              v.descricao_status_validador
            );
            return {
              ...v,
              descricao_status_validador: translated
            };
          });
          this.loading = false;
        },
        onError: () => {
          this.loading = false;
        }
      });

    },
    populaRelatorio() {
      this.$refs.form.validate();
      if (this.formValidado) {
        this.veiculos = [];
        this.populaVeiculos();
        this.$nextTick(() => { this.$refs.form.resetValidation(); });
      }
    },
    linhaChanged() {

    },
    empresaChanged() {
      this.populaLinhasSelect();
    },
    tipoCercaChanged() {
      if (this.idTipoCercaSelected) {
        let idCercasTipo = this.cercas.filter((c) => c.id_tipo_cerca === this.idTipoCercaSelected).map((c) => c.id_cerca);
        this.cercasSelect = this.cercasUnicas.filter((c) => idCercasTipo.includes(c.id_cerca));
      } else {
        this.cercasSelect = this.cercasUnicas;
      }
    },
    onMapPlotagemResize() {
      if (this.$refs.map && this.$refs.map.mapObject) {
        this.$refs.map.mapObject.invalidateSize();
      }
    },
    getPosicaoVeiculo(veiculo) {
      return L.latLng(veiculo.lat, veiculo.lng);
    },
    cercaChanged() {
      if (this.idCercasSelected.length > 0) {
        let cerca = this.cercasRelatorio[this.cercasRelatorio.length - 1];
        if (cerca && cerca.lat_centro && cerca.lng_centro) {
          this.currentCenter = [cerca.lat_centro, cerca.lng_centro];
        } else {
          // Fallback to default center if cerca data is incomplete
          this.currentCenter = [-22.88746, -43.29185];
        }
      } else {
        this.currentCenter = [-22.88746, -43.29185];
        this.veiculos = [];
      }
    },
    getIcon(veiculo) {
      let color = "none";
      let title = `${this.$t('geofenceVehicles.validator')}: ${veiculo.descricao_status_validador}`;
      let width = "30";
      let height = "30";

      if (veiculo.validador_offline == 1) {
        color = "red";
      } else if (veiculo.gps_offline == 1) {
        color = "orange";
      } else {
        color = "blue";
      }

      if (veiculo.id_veiculo == this.veiculoSelected) {
        width = "40";
        height = "40";
      } else {
        width = "30";
        height = "30";
      }

      return L.divIcon({
        className: 'my-custom-pin',
        html: `<svg width="${width}" height="${height}" viewBox="0 0 24 24" fill="#FFFFFF" xmlns="http://www.w3.org/2000/svg"><title>${title}</title>
                <path opacity="0.1" d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" fill="${color}"/>
                <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="${color}" stroke-width="2"/>
                <path d="M15 13L12.2014 10.2014V10.2014C12.0901 10.0901 11.9099 10.0901 11.7986 10.2014V10.2014L9 13" stroke="${color}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>`,
      });

    },
    veiculoClicked(veiculo) {
      this.veiculoSelected = veiculo.id_veiculo;
      this.currentCenter = [parseFloat(veiculo.lat), parseFloat(veiculo.lng)];
    }
  },
};
</script>